import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyKey = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 414,
	height: 290,
	viewBox: "0 0 414 290",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "o6ncxitwea",
		d: "M176.177 11.144C159.375 4.737 141.62-.616 123.497.057c-26.65.987-52.232 16.022-64.76 38.1-10.628 18.706-11.94 40.631-16.519 61.39-5.634 25.572-16.447 49.883-27.99 73.65-6.2 12.77-12.742 25.813-13.76 39.81-1.41 19.432 8.49 38.795 24.019 51.721 15.528 12.926 36.15 19.746 56.847 21.233 11.014.791 22.524.057 32.307-4.752 10.35-5.088 17.896-14.283 28.288-19.299 9.63-4.648 20.897-5.298 31.709-4.694 14.117.788 28.052 3.568 41.395 8.257 15.113 5.322 29.166 13.033 44.225 18.431 15.06 5.398 31.926 8.41 47.336 3.907 14.487-4.232 25.924-14.508 36.237-24.914 16.863-16.985 32.319-35.318 46.215-54.818 9.306-13.079 17.968-26.876 22.081-42.118 7.87-29.143-2.958-62.021-26.973-81.924-19.897-16.488-46.6-23.645-72.738-27.988-23.835-3.96-51.395-4.205-73.336-14.527-20.923-9.856-39.962-22.006-61.903-30.378z"
	}) }), /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", {
			transform: "translate(-545 -209) translate(545 209)",
			children: [/* @__PURE__ */ _jsx("use", {
				fill: "#FFF",
				xlinkHref: "#o6ncxitwea"
			}), /* @__PURE__ */ _jsx("use", {
				fill: "#174EFF",
				fillOpacity: .1,
				xlinkHref: "#o6ncxitwea"
			})]
		}), /* @__PURE__ */ _jsxs("g", {
			transform: "translate(-545 -209) translate(545 209) translate(95 44)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#2F2E41",
					fillRule: "nonzero",
					d: "M209.64 39.144c8.002 11.713 6.231 26.886 6.231 26.886s-14.744-3.817-22.745-15.53c-8.002-11.713-6.231-26.886-6.231-26.886s14.744 3.817 22.745 15.53z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#174EFF",
					d: "M203.883 41.38c.936 14.17 11.684 24.991 11.684 24.991s9.23-12.15 8.294-26.32c-.937-14.169-11.685-24.99-11.685-24.99s-9.23 12.15-8.293 26.32z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#D0CDE1",
					fillRule: "nonzero",
					d: "M112.014.295l108.638 54.799c1.847.931 2.957 2.883 2.818 4.952l-6.312 93.801c-.057.855-.538 1.623-1.28 2.047-.741.424-1.646.446-2.408.06L102.355 99.06l5.704-96.478c.055-.92.567-1.752 1.363-2.213.797-.46 1.77-.488 2.592-.074z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3F3D56",
					fillRule: "nonzero",
					d: "M113.264 2.207l105.97 53.452c1.802.909 2.885 2.812 2.749 4.83l-6.157 91.498c-.056.833-.525 1.583-1.249 1.997-.723.413-1.605.435-2.348.058L103.842 98.546l5.565-94.109c.053-.898.552-1.709 1.33-2.158.776-.45 1.726-.477 2.527-.072z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFF",
					fillRule: "nonzero",
					d: "M117.908 9.306l96.059 48.453c1.633.824 2.615 2.55 2.492 4.38l-5.581 82.939c-.051.755-.476 1.435-1.132 1.81-.656.375-1.456.394-2.13.053l-98.248-50.306 5.044-85.307c.048-.814.5-1.549 1.205-1.956.704-.407 1.565-.432 2.291-.066z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#D0CDE1",
					fillRule: "nonzero",
					d: "M18.79 145.216l108.777 54.962c2.053 1.035 4.474 1.032 6.524-.009l80.47-40.983c.944-.947.813-2.35.51-3.403-.146-.51-.345-1.003-.594-1.471l-10.966-5.787-92.197-46.152-5.508-2.933c-2.96-1.573-6.501-1.588-9.474-.039l-77.576 40.43c-1.006.521-1.635 1.566-1.628 2.703.007 1.136.65 2.173 1.662 2.682z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#000",
					fillRule: "nonzero",
					d: "M18.79 145.216l108.777 54.962c2.053 1.035 4.474 1.032 6.524-.009l80.47-40.983c.944-.947.813-2.35.51-3.403l-80.229 41.838c-1.986 1.036-4.345 1.056-6.349.055L17.167 142.03c-.215 1.304.443 2.596 1.623 3.185z",
					opacity: .1
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#000",
					fillRule: "nonzero",
					d: "M122.037 161.684l-35.228-17.86c-1.439-.73-3.142-.71-4.565.052L61.81 154.829c-.482.258-.78.764-.773 1.311.006.548.316 1.046.803 1.292l35.918 18.172c1.212.613 2.648.58 3.83-.088l20.517-11.597c.407-.23.654-.669.64-1.138-.014-.469-.286-.892-.707-1.097zM205.004 158.697L167.095 178.9c-.885.472-1.943.483-2.838.03L57.15 124.587c-.615-.312-1.002-.947-.999-1.639.003-.692.395-1.323 1.013-1.63l37.019-18.382c1.13-.562 2.46-.557 3.587.013l107.217 54.198c.29.147.474.444.478.77.003.325-.175.626-.461.779z",
					opacity: .1
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#174EFF",
					d: "M161.671 47.37L162.097 47.369 162.046 86.361 161.62 86.361z",
					transform: "rotate(-63.435 161.858 66.865)"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#174EFF",
					d: "M161.672 52.603L162.097 52.603 162.045 91.787 161.62 91.788z",
					transform: "rotate(-62.909 161.858 72.195)"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#174EFF",
					d: "M160.598 66.943L161.024 66.942 160.994 89.388 160.568 89.388z",
					transform: "rotate(-62.935 160.796 78.165)"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3F3D56",
					fillRule: "nonzero",
					d: "M41.783 94.205s-8.498-3.716-12.49.209c-3.992 3.925 10.688 2.633 12.49-.21z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#2F2E41",
					fillRule: "nonzero",
					d: "M27.108 76.584c2.856-4.842 8.507-5.068 8.507-5.068s5.506-.706 9.038 6.668c3.292 6.873 7.836 13.51.732 15.119L44.1 89.295l-.794 4.306c-1.012.073-2.027.09-3.04.052-7.609-.246-14.854.072-14.621-2.667.31-3.641-1.286-9.744 1.462-14.402z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFB8B8",
					fillRule: "nonzero",
					d: "M23.112 164.357s3.605 6.719 5.923 6.719 2.06 4.392 1.545 5.426c-.515 1.033-1.803 3.359.258 6.718.72 1.173.59 2.504.119 3.74-1.324 3.46-6.471 2.412-6.307-1.291l.007-.124c.257-4.134-1.803-10.594-3.863-12.144-2.06-1.55-3.864-5.684-3.864-5.684l6.182-3.36zM47.836 162.807s-3.606 6.718-5.924 6.718c-2.318 0-2.06 4.393-1.545 5.426.515 1.034 1.803 3.36-.258 6.719-.72 1.173-.59 2.504-.118 3.74 1.323 3.46 6.47 2.412 6.306-1.292l-.007-.123c-.257-4.134 1.803-10.594 3.864-12.144 2.06-1.55 3.863-5.685 3.863-5.685l-6.181-3.359z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#2F2E41",
					fillRule: "nonzero",
					d: "M45.003 129.733l1.545 3.36s22.664 7.493 20.604 16.278c-2.06 8.785-12.105 22.48-13.65 21.963-1.546-.517-9.787-2.067-10.044-6.46-.258-4.392 5.923-12.144 5.923-12.144l-8.499-7.752-12.367-.258-10.554 8.01s11.074 9.819 6.18 13.695c-4.893 3.875-12.104 6.46-13.134 4.909-1.03-1.55-12.62-24.547-10.817-26.614 1.803-2.067 20.089-9.819 20.089-9.819l4.893-6.976 19.058-1.034.773 2.842z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFB8B8",
					fillRule: "nonzero",
					d: "M40.367 87.099s-1.288 8.527 1.288 9.56c2.575 1.034-5.151 5.427-5.151 5.427h-4.378l-2.833-5.943s2.575-4.651 1.03-9.044c-1.546-4.393 10.044 0 10.044 0z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#000",
					fillRule: "nonzero",
					d: "M40.367 87.099s-1.288 8.527 1.288 9.56c2.575 1.034-5.151 5.427-5.151 5.427h-4.378l-2.833-5.943s2.575-4.651 1.03-9.044c-1.546-4.393 10.044 0 10.044 0z",
					opacity: .1
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#174EFF",
					d: "M42.17 94.334s-2.833 3.1-3.348 3.617c-.515.517-2.833 3.36-7.727-.775-4.893-4.134-5.408.775-5.408.775v31.007s4.12-1.809 7.469 0c3.348 1.809 10.302-.517 10.302-.517l1.287-32.04-2.575-2.067z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3F3D56",
					fillRule: "nonzero",
					d: "M40.278 94.334s2.407-1.034 4.467 0c2.06 1.033 9.272 6.201 8.757 8.527-.515 2.325-7.212 18.604-2.576 26.355 4.636 7.752 5.409 9.82 5.409 9.82l-11.332-5.944s-8.757-5.426-7.984-8.785c.773-3.359 3.259-29.973 3.259-29.973zM30.062 94.334s-5.405.517-5.663 1.033c-.257.517-8.112 2.714-7.597 5.039.515 2.326 7.597 23.126 4.507 27.002-3.09 3.876-8.242 9.302-6.439 9.819 1.803.516 4.893-.776 7.984 0 3.09.775 10.302-5.685 9.53-12.662-.774-6.976-.007-28.422-2.322-30.231z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFB8B8",
					fillRule: "nonzero",
					d: "M42.942 143.686v2.584s1.288 5.943-2.833 5.685c-4.12-.259-1.545-7.235-1.545-7.235l.258-2.326 4.12 1.292zM31.353 143.945s2.833 5.943 0 6.46c-2.833.516-4.893-3.36-4.893-4.393 0-1.034 4.893-2.067 4.893-2.067z"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 27.619,
					cy: 83.611,
					fill: "#FFB8B8",
					fillRule: "nonzero",
					rx: 1,
					ry: 1.034
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 42.814,
					cy: 83.611,
					fill: "#FFB8B8",
					fillRule: "nonzero",
					rx: 1,
					ry: 1.034
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3F3D56",
					fillRule: "nonzero",
					d: "M23.112 97.693s-6.44 0-6.182 2.584 8.757 47.027 8.757 47.027 3.606-3.36 6.696-2.584l-9.271-47.027zM48.093 98.468s6.439 1.292 6.439 5.168c0 3.876-9.272 41.084-10.56 41.084-1.287 0-6.18-.775-6.18-2.067 0-1.292 10.301-44.185 10.301-44.185z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#000",
					fillRule: "nonzero",
					d: "M46.677 106.09l-5.795 22.737s2.704-19.894 5.795-22.736zM24.137 102.896l5.861 29.726s-1.873-28.011-5.86-29.726z",
					opacity: .2
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 35.216,
					cy: 83.74,
					fill: "#FFB8B8",
					fillRule: "nonzero",
					rx: 7.469,
					ry: 7.493
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#2F2E41",
					fillRule: "nonzero",
					d: "M28.371 76.117L33.953 73.183 41.663 74.383 43.257 81.451 39.287 81.298 38.178 78.701 38.178 81.255 36.346 81.184 35.282 77.05 34.618 81.451 28.105 81.318z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFF",
					fillRule: "nonzero",
					d: "M128.555 13.463L128.981 13.463 128.951 35.908 128.525 35.908z",
					transform: "rotate(-62.935 128.753 24.686)"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFF",
					fillRule: "nonzero",
					d: "M127.058 17.069L127.484 17.068 127.454 39.513 127.028 39.514z",
					transform: "rotate(-62.935 127.256 28.29)"
				})
			]
		})] }) })
	})]
});
export default SvgEmptyKey;
